export const ACCOUNT_TYPES = {
	PERSONAL_BROKERAGE: 'PERSONAL_BROKERAGE',
	ROBO_PERSONAL_BROKERAGE: 'ROBO_PERSONAL_BROKERAGE',
	TRADITIONAL_IRA: 'TRADITIONAL_IRA',
	ROTH_IRA: 'ROTH_IRA',
	CUSTODIAN: 'CUSTODIAN',
	DEBIT: 'DEBIT',
	BANK_DDA: 'BANK_DDA',
} as const;
export type AccountType = typeof ACCOUNT_TYPES[keyof typeof ACCOUNT_TYPES];

export const MANAGEMENT_TYPES = {
    SELF_DIRECTED: 'SELF_DIRECTED',
    ROBO: 'ROBO',
} as const;
export type ManagementType = typeof MANAGEMENT_TYPES[keyof typeof MANAGEMENT_TYPES];